import { NgModule, Injector } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

// services
import { FormService } from '../../services/form/form.service';
import { TextMaskModule } from 'angular2-text-mask';

// Base form components
import { BasicTextInputComponent } from './base-components/base-text-input/basic-text-input.component';
import { BasicLabelComponent } from './base-components/basic-label/basic-label.component';
import { BasicCheckboxComponent } from './base-components/basic-checkbox/basic-checkbox.component';
import { QuestionTextComponent } from './base-components/question-text/question-text.component';
import { RadioGroupComponent } from './base-components/radio-group/radio-group.component';
import { SelectBasicComponent } from './base-components/select-basic/select-basic.component';
import { SelectAutoCompleteComponent } from './base-components/select-autocomplete/select-autocomplete.component';
import { DynamicValidationComponent } from './dynamic-validation/dynamic-validation.component';
import { ReactiveTextFieldComponent } from './reactive-components/reactive-text-field/reactive-text-field.component';
import { ParserService } from '../../../../common/angular-shared/services/parser/parser.service';
import { CPSearchBoxComponent } from './reactive-components/cp-search-box/cp-search-box.component';

@NgModule({
  declarations: [
    BasicTextInputComponent,
    BasicLabelComponent,
    BasicCheckboxComponent,
    QuestionTextComponent,
    RadioGroupComponent,
    SelectBasicComponent,
    SelectAutoCompleteComponent,
    DynamicValidationComponent,
    ReactiveTextFieldComponent,
    CPSearchBoxComponent,
  ],
  imports: [FormsModule, ReactiveFormsModule, CommonModule, TextMaskModule],
  providers: [FormService, ParserService],
  exports: [
    BasicTextInputComponent,
    BasicLabelComponent,
    BasicCheckboxComponent,
    QuestionTextComponent,

    RadioGroupComponent,
    SelectBasicComponent,
    SelectAutoCompleteComponent,
    DynamicValidationComponent,
    ReactiveTextFieldComponent,
    CPSearchBoxComponent,
  ],
})
export class BaseFormModule {}
